import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Loading from "./Loading";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <Loading text="Checking access..." fullHeight />;
  }

  return user ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
